export const URL_ZIP_FILE_SOURCE = 'url'
export const UPLOAD_ZIP_FILE_SOURCE = 'upload'
export type ZipFileSources = 'url' | 'upload'

export const OTHER_SOURCE = 'other'
